var config = require('../../../config/config');
var axios = require('axios');
var Storage = require('../../helper/storage');

function Request(app){
  var self = this;
  self.apiUrl = config.messageApiUrl;
  self.socketUrl = config.messageApiUrl.replace('https://', 'wss://') + "/socket";
  self.response;
  self.retrieve = 0;
  self.app = app;
  self.tokenUri = "/iam/access/token";
  self.storage = new Storage();
  if (self.storage.store.getItem("token") === "undefined" ||
      self.storage.store.getItem("token") === null){
    self.request = axios.create({
      baseUrl: self.apiUrl,
      headers: {
        'Content-Type': 'application/json',
        'X-Ahtapot-Company': new Buffer(String(app.companyId)).toString("base64"),
        'X-Ahtapot-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        'Accept': 'application/json'
      },
      responseType: 'json',
      xsrfCookieName: null,
      xsrfHeaderName: null
    });
  } else {
    self.request = axios.create({
      baseUrl: self.apiUrl,
      headers: {
        'Content-Type': 'application/json',
        'X-Ahtapot-Company': new Buffer(String(app.companyId)).toString("base64"),
        'X-Ahtapot-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        'Authorization': 'Bearer '+self.storage.store.getItem("token"),
        'Accept': 'application/json'
      },
      responseType: 'json',
      xsrfCookieName: null,
      xsrfHeaderName: null
    });
  }

  self.request.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error.response){
      const originalRequest = error.config;
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        var tokenRequest = axios.create({
          headers: {
            'Content-Type': 'application/json',
            'X-Ahtapot-Company': new Buffer(String(app.companyId)).toString("base64"),
            'X-Ahtapot-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
            'Accept': 'application/json'
          },
          responseType: 'json',
          xsrfCookieName: null,
          xsrfHeaderName: null
        });

        return tokenRequest.post(self.apiUrl + self.tokenUri, {
          passphrase_submission: {
            passphrase: self.storage.store.getItem('passphrase')    
          }
        }).then(function(response){
          response = self.successHandler(response);
          var token = response.data.token.jwt;
          self.storage.store.setItem('token', token);
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          return axios(originalRequest);
        })
      }
    }
    return Promise.reject(error);
  });
}

Request.prototype.get = function(uri){
  var self = this;
  var url = self.apiUrl + uri;
  return self.request.get(url);
}

Request.prototype.post = function(uri, data){
  var self = this;
  var url = self.apiUrl + uri;
  return self.request.post(url, data)
}

Request.prototype.put = function(uri, data){
  var self = this;
  var url = self.apiUrl + uri;
  return self.request.put(url, data);
}

Request.prototype.patch = function(uri, data){
  var self = this;
  var url = self.apiUrl + uri;
  return self.request.put(url, data)
}

Request.prototype.delete = function(uri){
  var self = this;
  var url = self.apiUrl + uri;
  return self.request.delete(url);
}

Request.prototype.successHandler = function(response){
  var self = this;
  return successData = {
    status: response.status,
    data: response.data
  }
}

Request.prototype.errorHandler = function(error){
  var self = this;
  return errorData = {
    status: error.response.status,
    detail: (typeof error.response.data.errors !== "undefined" ? error.response.data.errors.detail : null),
    message: (typeof error.response.data.errors !== "undefined" ? error.response.data.errors.name : null)
  };
}

module.exports = Request;
